import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { computed, onBeforeUnmount, onMounted, ref } from 'vue'

import AdBlock from '@/components_new/AdBlock.vue'
import type { PageAdSize } from '@/modules/adv'

const REFETCH_FAILED_AD_MS = 60_000


export default /*@__PURE__*/_defineComponent({
  __name: 'AdFlipCards',
  props: {
    frontDurationMs: { default: 15000 },
    backDurationMs: { default: 60000 },
    adMode: {},
    sizes: {}
  },
  setup(__props: any) {

const props = __props

const isBackVisible = ref(false)
const adMounted = ref(false)
const timerFront = ref<ReturnType<typeof setTimeout> | null>(null)
const timerBack = ref<ReturnType<typeof setTimeout> | null>(null)

const adMobileUnit = computed(() => (props.adMode === 'widget' ? 'widget_sticky_mobile' : 'sticky_mobile'))
const adTabletUnit = computed(() => (props.adMode === 'widget' ? 'widget_sticky_tablet' : 'sticky_tablet'))

function scheduleNextAd(customDurationMs?: number) {
    resetTimers()
    timerFront.value = setTimeout(() => {
        adMounted.value = true
    }, customDurationMs ?? props.frontDurationMs)
}

function scheduleFailAd() {
    adMounted.value = false
    isBackVisible.value = false
    scheduleNextAd(REFETCH_FAILED_AD_MS)
}

function scheduleNextFront() {
    timerBack.value = setTimeout(() => {
        isBackVisible.value = false
    }, props.backDurationMs)
}

function resetTimers() {
    clearTimeout(timerFront.value!)
    clearTimeout(timerBack.value!)
}

function onAdVisibilityChanged(isVisible: boolean) {
    if (isVisible) {
        isBackVisible.value = true
        scheduleNextFront()
    } else {
        scheduleFailAd()
    }
}

function handleTransitionBackEnd() {
    if (!isBackVisible.value) {
        adMounted.value = false
        scheduleNextAd()
    }
}

onMounted(() => {
    scheduleNextAd()
})

onBeforeUnmount(() => {
    resetTimers()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.container)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.$style.front, isBackVisible.value && _ctx.$style.hideUnder])
    }, [
      _renderSlot(_ctx.$slots, "front")
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.$style.back, isBackVisible.value && _ctx.$style.visible]),
      onTransitionend: handleTransitionBackEnd
    }, [
      (adMounted.value)
        ? (_openBlock(), _createBlock(AdBlock, {
            key: 0,
            class: _normalizeClass(_ctx.$style.mobile),
            type: adMobileUnit.value,
            "onUpdate:visible": onAdVisibilityChanged
          }, null, 8, ["class", "type"]))
        : _createCommentVNode("", true),
      (adMounted.value)
        ? (_openBlock(), _createBlock(AdBlock, {
            key: 1,
            class: _normalizeClass(_ctx.$style.tablet),
            type: adTabletUnit.value,
            "onUpdate:visible": onAdVisibilityChanged
          }, null, 8, ["class", "type"]))
        : _createCommentVNode("", true)
    ], 34)
  ], 2))
}
}

})